<template>
  	<el-dialog :visible.sync="openStatus" class="create-subnet-container"
        :title="$t('subnet.text.openIpv6')" :close-on-click-modal="false" v-if="dialogVisible"
        @close="doClose">
	    <el-form class="jc-form cps-create-form" label-width="140px" ref="ruleForm">
	        <!-- VPC IPv6 CIDR -->
	        <el-form-item
	            :label="$t('subnet.text.vpcIpv6Cidr') | withColon">
	            {{currentRow.vpcIpv6Cidr}}
	        </el-form-item>
	        <!-- 子网主要IPv6 CIDR -->
	        <el-form-item
	            :label="$t('subnet.text.subnetIpv6Cidr') | withColon">
	            <ipv6-cidr 
	                :cidr-array="[ipv6Cidr1Val,ipv6Cidr2Val,ipv6Cidr3Val]"
	                @ipv6CidrVal="ipv6CidrChange"
	            ></ipv6-cidr>
	        </el-form-item>
	    </el-form>
	    <span slot="footer" class="dialog-footer">
	        <el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
	        <el-button @click="doConfirm" type="primary">{{ $t('detail.text.sure') }}</el-button>
	    </span>
  	</el-dialog>
</template>

<script>
import ipv6Cidr from '@/components/subnet/ipv6Cidr/Ipv6Cidr';
const validateLength = (rule, value, callback) => {
    if (value.length > 256) {
        callback(new Error());
    } else {
        callback();
    }
};
export default {
    components: {
        ipv6Cidr
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: true,
        },
        region: {
            type: String,
            default: ''
        },
        currentRow: {
        	type: Object,
        	default: () => {}
        }

    },
    data() {
        return {
            openStatus: this.dialogVisible,
            ipv6Cidr1Val: '', 
            ipv6Cidr2Val: '0',
            ipv6Cidr3Val: '',
            isLegalIpv6Cidr: false  
        };
    },
    watch: {
        ipv6DialogVisible(val) {
            this.openStatus = val;
        },
    },
    mounted() {
    	this.$nextTick(() => {
    		this.getSubnetCountForCurrentVpc();
      	})
    },
    methods: {
        // 关闭弹框
        doClose() {
            this.$emit('ifIpv6DialogVisible', false);
        },
        // 点击确认按钮
        doConfirm() {
 			this.enableIpv6()
        },
        // 清空表单
        doReset(formName) {
            this.ipv6Cidr1Val = 10;
            this.ipv6Cidr2Val = 0;
            this.ipv6Cidr3Val = 0;
        },
        // 获得当前vpc下子网个数
        getSubnetCountForCurrentVpc() {
            this.vpcIpv6Cidr = this.currentRow.vpcIpv6Cidr;
            if (this.vpcIpv6Cidr) {
                let ipv6Cidr1 = this.vpcIpv6Cidr.split('::')[0];
                this.ipv6Cidr1Val = ipv6Cidr1.substr(0,ipv6Cidr1.length-1);
                this.ipv6Cidr3Val = 64;
            }
        },
        // 开通ipv6
        enableIpv6() {
            if (!this.isLegalIpv6Cidr) {
                if (this.ipv6Cidr2Val !== '0') {
                    return
                } 
            } 
        	let params = {
        		region: this.region,
        		subnetId: this.currentRow.subnetId
        	}
        	if (this.ipv6Cidr2Val) {
        		params.ipv6Cidr = this.ipv6Cidr1Val + this.ipv6Cidr2Val + '::/' + this.ipv6Cidr3Val;
        	}
            Ajax.post('/api/cps/subnets/assignIpv6Cidr', params)
            .then(() => {
				this.$emit('refreshList');
				this.doClose();
            })
            .catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
            })
            .finally(() => {
            	this.doClose();
            });
        },
        ipv6CidrChange(ipv6CidrArray) {
            [this.ipv6Cidr1Val, this.ipv6Cidr2Val,this.ipv6Cidr3Val,this.isLegalIpv6Cidr] = ipv6CidrArray
        }
    }
};
</script>

<style lang="scss">
    @import '../../../assets/scss/createCommon';
    @import 'ipv6Subnet';
</style>



// WEBPACK FOOTER //
// src/components/subnet/ipv6Subnet/ipv6Subnet.vue